import { FC } from 'react';

import { Layout } from '../../Layout';
import { ReactComponent as Brand } from './brand.svg';
import styles from './LoadingPage.module.scss';

export const LoadingPage: FC = () => {
  return (
    <Layout fullWidth>
      <div className={styles.container}>
        <Brand />
      </div>
    </Layout>
  );
};
